export { default } from "./getHasSpanishLanguageLevel";
